module.exports = __webpack_public_path__ + "img/Group 26.268313d9.svg";